export const debounce = (fn: () => any, delay = 100) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  function debounced(...args: any) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      fn.apply({}, args);
    }, delay);
  }

  debounced.clear = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = undefined;
    }
  };

  return debounced;
};
